BaseLayer = App.loadClass "grower::viewmodels/prescription_map/Layer"

class exports.Layer extends BaseLayer


    constructor: (parent, data = {}, deps = {}) ->
        super parent, data, deps
        @setInitialDeps()
        @syncDeps deps

        @ignore [
            'num_pop_options'
            'min_pop_diff_options'
            'max_pop_diff_options'
            'calculated_pop'
        ]


        @hybrid_id          = data.prescription_map?.hybrids_id ? 634
        @machinery_id       = ko.observable data.prescription_map?.machinery_planters_id


        @target_population  = ko.observable data.prescription_map?.target_population ? 0
        @min_population     = ko.observable data.prescription_map?.minimum_population ? null
        @max_population     = ko.observable data.prescription_map?.maximum_population ? null


        @target_population.subscribe (tval) =>
            if tval.toString().indexOf(',') isnt -1
                t = parseInt(tval.toString().replace(',', ''))
                @target_population t

        @min_population.subscribe (min) =>
            if min.toString().indexOf(',') isnt -1
                t = parseInt(min.toString().replace(',', ''))
                @min_population t

        @max_population.subscribe (max) =>
            if max.toString().indexOf(',') isnt -1
                t = parseInt(max.toString().replace(',', ''))
                @max_population t

        @num_populations    = ko.observable data.prescription_map?.max_number_of_populations ? 3
        @min_pop_diff       = ko.observable data.prescription_map?.min_population_difference ? 1000
        @max_pop_diff       = ko.observable data.prescription_map?.max_population_difference ? 1500


        @was_recalculated   = ko.observable true


        # Sources for dropdowns
        @num_pop_options        = [1..30]

        @min_pop_diff_options   = [100, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]
        @max_pop_diff_options   = [100, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]

        @planters               = data.planters ? []


        @controller = ko.computed () =>
            mach = null
            for k in @planters
                if k.id is @machinery_id()
                    mach = k
                    break

            if mach?
                con_mod     = mach.controller_model.name
                con_make    = mach.controller_model.make.name
                return "#{con_mod} - #{con_make}"

            return ''



        @calculated_pop = ko.computed () =>
            averaging = 0
            for k in @stages
                mypop = parseFloat(k.field_soil_acres) * parseFloat(k.population())
                averaging += mypop

            if averaging? and @total_acres()?
                return parseInt(averaging / @total_acres())

            return 0


        ###
        Fun tricks for deciding if the recalculate
        button should be switched to green to indicate
        something has changed and recalculation is necessary.

        Basically, KO detects dependencies for computed by
        keeping track of which observables were read from during
        the computed's calculation. So we just read from all the
        variables that will cause the button to change to green when updated,
        forcing those variables to be tracked as dependencies of this
        computed.
        ###
        @update_button = ko.computed () =>
            @machinery_id()

            @target_population()
            @min_population()
            @max_population()

            @num_populations()
            @min_pop_diff()
            @max_pop_diff()

            # This handles the case when we have just clicked the
            # recalculate button. Clicking it causes was_recalculated to be true
            # so we will catch that special case and cause the button to be
            # boring gray if we just recalculated.
            if @was_recalculated()
                @was_recalculated(false)
                return 'btn span12 rx_map-recalc_btn'

            return 'btn btn-primary span12 rx_map-recalc_btn'

